function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#495A95"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.3144 23.3143C19.2002 27.4292 14.5873 28.5477 13.8006 28.1688L11.7864 25.8539C11.7871 25.8517 11.7877 25.8494 11.7886 25.8472L14.688 23.5506L15.4677 24.7228C15.4831 24.7459 15.4995 24.7683 15.5168 24.7897C15.7806 25.1157 16.1695 25.3081 16.6117 25.3312C17.0428 25.3543 18.3526 25.4228 21.8877 21.887C22.762 21.0125 25.4224 18.3517 25.3311 16.611C25.3077 16.1683 25.1155 15.7794 24.7897 15.5154C24.7682 15.4978 24.7459 15.4816 24.7228 15.4663L23.5504 14.6861L25.8468 11.787C25.8493 11.7861 25.8517 11.7852 25.8544 11.7843L28.168 13.799C28.5468 14.5861 27.4288 19.1987 23.3144 23.3143ZM29.4397 12.5519C29.4253 12.5374 29.4102 12.5234 29.3948 12.5101L27.0066 10.4303C26.6782 10.1179 26.2144 9.96367 25.7284 10.0066C25.2951 10.0443 24.8759 10.237 24.5784 10.5348C24.5544 10.559 24.5317 10.5843 24.5106 10.611L22.1646 13.5725C21.5522 14.2308 21.5662 15.265 22.2064 15.9061C22.2482 15.9479 22.294 15.9852 22.3428 16.0178L23.5424 16.8163C23.4471 17.2321 22.8211 18.4388 20.6308 20.6297C18.4404 22.8206 17.2335 23.4468 16.8177 23.5423L16.0197 22.3428C15.9871 22.2937 15.9497 22.2479 15.9079 22.2063C15.2668 21.5654 14.2326 21.5514 13.5746 22.1643L10.6133 24.5101C10.5862 24.5316 10.5606 24.5545 10.5362 24.579C9.85996 25.2565 9.8164 26.3592 10.4333 27.0072L12.5122 29.3959C12.5255 29.4114 12.5395 29.4265 12.5539 29.441C12.9646 29.8516 13.5806 29.9994 14.2553 29.9994C15.4737 29.9994 16.8828 29.5168 17.6153 29.2288C19.0311 28.6717 21.8173 27.3259 24.5713 24.5714C26.6124 22.5299 28.2662 20.059 29.2277 17.6141C29.6753 16.4761 30.5922 13.7045 29.4397 12.5519Z",
  fill: "#495A95"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(10 10)"
})));

var SvgIconPhone = function SvgIconPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_phone.33817c08.svg";
export { ForwardRef as ReactComponent };